import React, { useState } from 'react';
import { Alert, Link } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';

const DISMISS_KEY = 'emailBannerDismissed';

const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === 'true'
  );
  const [resending, setResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);

  if (!user || user.emailVerified || dismissed) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  const handleResend = async () => {
    if (!user.email) return;
    setResending(true);
    try {
      await authAPI.resendVerificationEmail(user.email);
      setResendSuccess(true);
    } catch (err) {
      console.error('Failed to resend verification email:', err);
    } finally {
      setResending(false);
    }
  };

  return (
    <Alert
      severity="info"
      onClose={handleDismiss}
      sx={{ borderRadius: 0 }}
    >
      {resendSuccess ? (
        'Verification email sent! Check your inbox.'
      ) : (
        <>
          Please verify your email to receive alerts and enable password reset.{' '}
          <Link
            component="button"
            variant="body2"
            onClick={handleResend}
            disabled={resending}
            sx={{ verticalAlign: 'baseline' }}
          >
            {resending ? 'Sending...' : 'Resend verification email'}
          </Link>
        </>
      )}
    </Alert>
  );
};

export default EmailVerificationBanner;
